import { HourglassOutlined, RocketOutlined } from '@ant-design/icons';
import { Button, message } from 'antd';
import { useContext, useState } from 'react';
import { createCheckoutSession } from 'services/api/users';
import ProfileContext from 'services/profileContext';
import styles from 'styles/components/profileValidationBanner.module.scss';
import { SESSION_PENDING_PRO_CHECKOUT } from 'utils/constants';
import { usePostHogFeatureFlag } from 'hooks/usePostHogFeatureFlag';

const ProfileValidationBanner = () => {
  const profileContext = useContext(ProfileContext);
  const profile = profileContext?.profile;
  const proPlansEnabled = usePostHogFeatureFlag('pro-plan');
  const [checkoutLoading, setCheckoutLoading] = useState(false);

  const validation = profile?.profileValidation;
  const status = validation?.status;
  if (status !== 'pending') {
    return null;
  }

  const isPreview = validation?.opportunitiesPreview === true;

  const handleUpgrade = async () => {
    setCheckoutLoading(true);
    try {
      const { data } = await createCheckoutSession();
      sessionStorage.setItem(SESSION_PENDING_PRO_CHECKOUT, '1');
      window.location.href = data.url;
    } catch (err) {
      message.error('Could not start checkout. Please try again.');
      setCheckoutLoading(false);
    }
  };

  const messageText = isPreview
    ? proPlansEnabled
      ? 'Your profile is being validated. You’re seeing a preview of opportunities — upgrade to Pro for the full list.'
      : 'Your profile is being validated. You’re seeing a preview of opportunities while you wait.'
    : proPlansEnabled
    ? 'Your profile is being validated. You can browse opportunities while you wait — upgrade to Pro for full marketplace access now.'
    : 'Your profile is being validated. You can browse opportunities while you wait.';

  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <HourglassOutlined className={styles.icon} />
        <span className={styles.message}>{messageText}</span>
        {proPlansEnabled && (
          <Button
            type="primary"
            size="small"
            icon={<RocketOutlined />}
            loading={checkoutLoading}
            onClick={handleUpgrade}
            className={styles.cta}
          >
            Upgrade to Pro
          </Button>
        )}
      </div>
    </div>
  );
};

export default ProfileValidationBanner;
